import gql from 'graphql-tag';

import { FOOTER_ICON_LINK_FRAGMENT } from './footerIconLink';
import { FOOTER_MENU_LINK_FRAGMENT } from './footerMenuLinks';

export const FOOTER_FRAGMENT = gql`
  fragment footer on FooterType {
    createdAt
    updatedAt
    id
    logo
    text
    buttonText
    buttonUrl
    menuLinks {
      edges {
        node {
          ...footerMenuLink
        }
      }
    }
    iconLinks {
      edges {
        node {
          ...footerIconLink
        }
      }
    }
  }
  ${FOOTER_ICON_LINK_FRAGMENT}
  ${FOOTER_MENU_LINK_FRAGMENT}
`;
